import React, { useCallback } from "react";
import { useResponsive } from "../hooks/useResponsive";
import { Divider, Typography } from "@mui/material";
import CustomMenuItem from "./Menu/CustomMenuItem";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";

export const FilterOptionsList = React.memo(({
  options = [],
  paramsKey = "",
  clickHandler,
  className = "",
  filterType = "",
  }) => {
  const isMobile = useResponsive("down", "md");

  const [userFilter, updateParams, removeSearchParam] = useCustomSearchParams(paramsKey); // Ensure this returns a function

  const handleClick = useCallback((value) => {
    updateParams(paramsKey, value); // Ensure updateParams is a function
  }, [updateParams, paramsKey]);


  return options?.map((option, index) =>
    isMobile ? (
      <Typography
        key={option?.value}
        className={`workflow_steps pl-2 ${
          filterType === option.value ? "active" : ""
        } ${className}`}
        onClick={() => {
          clickHandler ? clickHandler() : handleClick(option.value);
        }}
      >
        {option.label}
      </Typography>
    ) : (
      <div key={option.value}>
        <CustomMenuItem
          className={`menu-item ${className}`}
          onClick={() => (clickHandler ? clickHandler() : handleClick(option.value))
          }
        >
          {option.label}
        </CustomMenuItem>
        {index !== options.length - 1 && <Divider className="divider" />}
      </div>
    )
  );
});
